<div class="queue-list">
  <!-- Header -->
  <div class="d-flex align-items-start justify-content-between flex-wrap gap-3 mb-4">
    <div>
      <h4 class="mb-2">{{ 'Settings::Queues:Title' | abpLocalization }}</h4>
      <p class="text-muted mb-0">{{ 'Settings::Queues:Description' | abpLocalization }}</p>
    </div>
    <div class="d-flex align-items-center flex-wrap gap-2">
      <p-iconfield iconPosition="left" class="queue-list__search">
        <p-inputicon class="pi pi-search"></p-inputicon>
        <input
          type="text"
          pInputText
          class="small"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
          [placeholder]="'Settings::Queues:SearchPlaceholder' | abpLocalization" />
      </p-iconfield>
      <button type="button" class="btn btn-primary btn-sm" (click)="newQueue.emit()">
        <i class="pi pi-plus pi-fw me-1"></i>
        {{ 'Settings::Queues:NewQueue' | abpLocalization }}
      </button>
    </div>
  </div>

  <!-- Stats -->
  <div class="d-flex align-items-center mb-4">
    <div
      class="queue-list__stat d-flex flex-column py-2 px-3 rounded user-select-none"
      (click)="setStatusFilter('all')">
      <span
        class="queue-list__stat-value fs-4 fw-bold lh-sm"
        [class.text-primary]="statusFilter === 'all'">
        {{ totalCount }}
      </span>
      <span
        class="queue-list__stat-label small fw-semibold text-uppercase"
        [class.text-primary]="statusFilter === 'all'">
        {{ 'Settings::Queues:TotalQueues' | abpLocalization }}
      </span>
    </div>
    <div class="queue-list__stat-divider"></div>
    <div
      class="queue-list__stat d-flex flex-column py-2 px-3 rounded user-select-none"
      (click)="setStatusFilter('active')">
      <span
        class="queue-list__stat-value fs-4 fw-bold lh-sm"
        [class.text-primary]="statusFilter === 'active'">
        {{ activeCount }}
      </span>
      <span
        class="queue-list__stat-label small fw-semibold text-uppercase"
        [class.text-primary]="statusFilter === 'active'">
        {{ 'Settings::Queues:Active' | abpLocalization }}
      </span>
    </div>
    <div class="queue-list__stat-divider"></div>
    <div
      class="queue-list__stat d-flex flex-column py-2 px-3 rounded user-select-none"
      (click)="setStatusFilter('inactive')">
      <span
        class="queue-list__stat-value fs-4 fw-bold lh-sm"
        [class.text-primary]="statusFilter === 'inactive'">
        {{ inactiveCount }}
      </span>
      <span
        class="queue-list__stat-label small fw-semibold text-uppercase"
        [class.text-primary]="statusFilter === 'inactive'">
        {{ 'Settings::Queues:Inactive' | abpLocalization }}
      </span>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="queue-list__loading d-flex justify-content-center py-5 fs-4">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <!-- Cards Grid -->
  <div *ngIf="!loading" class="queue-list__grid d-grid gap-3">
    <app-queue-card
      *ngFor="let queue of pagedQueues; trackBy: trackByQueueId"
      [queue]="queue"
      (cardClick)="onCardClick($event)" />
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && filteredQueues.length === 0" class="queue-list__empty text-center py-5">
    <p>{{ 'Settings::Queues:EmptyMessage' | abpLocalization }}</p>
  </div>

  <!-- Pagination -->
  <div *ngIf="showPagination" class="d-flex align-items-center justify-content-center gap-3 mt-4">
    <button
      class="btn btn-sm btn-outline-secondary"
      [disabled]="currentPage === 0"
      (click)="goToPage(currentPage - 1)">
      <i class="pi pi-chevron-left"></i>
    </button>
    <span class="queue-list__page-info small">{{ currentPage + 1 }} / {{ totalPages }}</span>
    <button
      class="btn btn-sm btn-outline-secondary"
      [disabled]="currentPage === totalPages - 1"
      (click)="goToPage(currentPage + 1)">
      <i class="pi pi-chevron-right"></i>
    </button>
  </div>
</div>
